import * as yup from 'yup';

const ResetTempPasswordFormValidation = yup.object().shape({
  password: yup.string().trim().required('Temporary password is a required field'),
  name: yup.string().trim().email().required('Email is a required field'),
  newPassword: yup.string()
    .required('Please enter the password')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&^_\-+{}[\];:'"<>,.?\\/])[A-Za-z\d@$!%*#?&^_\-+{}[\];:'"<>,.?\\/]{8,}$/g,
      'Your password does not meet our password rules. Use at least 8 characters, 1 special character, 1 uppercase, 1 lowercase, and 1 number',
    ),
  confirmPassword: yup
    .string()
    .trim()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
});
export default ResetTempPasswordFormValidation;
